

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface FloorParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface Floor {
    id?: number;
    tenantId: any;
    branchId: any;
    floorId?:any;
    name:string; 
    buildingId:any;
    
    building?:any;
    floor?:any;
  parameters?: FloorParameter[];
  links?: any;
}

export abstract class FloorData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(url: string): Observable<Floor[]>;
  abstract create(url: string, data: Floor): Observable<Floor[]>;
  abstract update(url: string, data: Floor): Observable<Floor>;
  abstract delete(url: string): Observable<any>;
 
}
